import { Collection } from '../collection.model';
import { SearchResult } from '../search/models/search-result.model';

export class CollectionSearchResult extends SearchResult<Collection> {
}
